
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatStep, MatStepperModule } from '@angular/material/stepper';
import { FieldType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'itc-formly-field-stepper',
  template: `
    <mat-horizontal-stepper [linear]="true">
      @for (
        step of field.fieldGroup; track
        step; let index = $index; let last = $last) {
        <mat-step
          [completed]="isValid(step)"
          >
          <ng-template matStepLabel>{{ step.props.label }}</ng-template>
          <formly-field [field]="step"></formly-field>
          <div class="formly-field-button">
            @if (index !== 0) {
              <button
                matStepperPrevious
                class="btn btn-primary"
                type="button"
                >
                Back
              </button>
            }
            @if (!last) {
              <button
                matStepperNext
                class="btn btn-primary"
                type="button"
                [disabled]="!isValid(step)"
                >
                Next
              </button>
            }
          </div>
        </mat-step>
      }
    </mat-horizontal-stepper>
    `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormlyModule, MatStep, MatStepperModule],
})
export class StepperComponent extends FieldType {
  isValid(field: FormlyFieldConfig) {
    if (field.key) {
      return field.formControl.valid;
    }

    return field.fieldGroup
      ? field.fieldGroup.every((f) => this.isValid(f))
      : true;
  }
}
